import alignText from 'align-text';
import chalk from 'chalk';
import { trace } from '@opentelemetry/api';
const LEVEL = {
    DEBUG: 'debug',
    INFO: 'info',
    WARNING: 'warning',
    ERROR: 'error',
};
const COLOR = {
    [LEVEL.DEBUG]: 'bgCyan',
    [LEVEL.INFO]: 'bgGreen',
    [LEVEL.WARNING]: 'bgYellow',
    [LEVEL.ERROR]: 'bgRed',
};
function formatException(exception) {
    const output = `\n${chalk.redBright('Exception')}:`;
    if (exception.stack) {
        const line = alignText(`${chalk.whiteBright('message')}: ${exception.message}\n${chalk.whiteBright('stack')}: ${exception.stack}`, 2);
        return `${output}\n${line}`;
    }
    return `${output} ${exception.message}`;
}
function stringWriter(args) {
    const { context, level, message, meta, exception, request_url: requestUrl, http_status: httpStatus, 
    // TODO responseTime
    // eslint-disable-next-line @typescript-eslint/naming-convention
    response_time, request_method: requestMethod, 
    // изменяемый заголовок, его может править nginx и мы перезатрем реальный IP по пути в продукт
    x_real_ip: xRealIp, 
    // кастомный фларовский заголовок, его ничто не перезапишет
    real_ip: realIp, cf_ray: cfRay, src_port: srcPort, utmz, asn, ja3, query_params: queryParams, trace_id: traceId, span_id: spanId, caller, } = args;
    const levelColor = COLOR[level];
    const formattedContext = `${chalk.bold.cyanBright(context)}`;
    const formattedLevel = chalk[levelColor].black('', level.toUpperCase(), '');
    const formattedUrl = requestUrl ? chalk.whiteBright(requestUrl) : null;
    let formattedStatus = null;
    if (httpStatus) {
        if (httpStatus >= 400) {
            formattedStatus = chalk.red(httpStatus);
        }
        else {
            formattedStatus = chalk.yellow(httpStatus);
        }
    }
    const formattedMeta = meta
        ? alignText(`\n${chalk.magentaBright('Meta')}: ${JSON.stringify(meta, null, 2)}`, 9)
        : null;
    const formattedException = exception ? alignText(formatException(exception), 9) : null;
    const output = [
        new Date().toLocaleTimeString('ru'),
        formattedLevel,
        formattedContext,
        formattedStatus,
        formattedUrl,
        response_time,
        message,
        formattedMeta,
        formattedException,
        requestMethod,
        utmz,
        asn,
        ja3,
        xRealIp,
        realIp,
        cfRay,
        srcPort,
        queryParams,
        traceId,
        spanId,
        caller,
    ]
        .filter(Boolean)
        .join(' ');
    // eslint-disable-next-line no-console
    console.log(output);
}
function jsonWriter(args) {
    const { context, level, message, meta, exception, request_url: requestUrl, http_status: httpStatus, response_time: responseTime, request_method: requestMethod, utmz, asn, ja3, x_real_ip: xRealIp, real_ip: realIp, cf_ray: cfRay, src_port: srcPort, query_params: queryParams, trace_id: traceId, span_id: spanId, caller, } = args;
    // eslint-disable-next-line no-console
    console.log(JSON.stringify({
        level: level.toUpperCase(),
        context,
        http_status: httpStatus,
        request_url: requestUrl,
        response_time: responseTime,
        message,
        meta: meta ? JSON.stringify(meta) : null,
        exception: exception ? JSON.stringify(exception) : null,
        request_method: requestMethod,
        utmz,
        asn,
        ja3,
        x_real_ip: xRealIp,
        real_ip: realIp,
        cf_ray: cfRay,
        src_port: srcPort,
        query_params: queryParams,
        trace_id: traceId,
        span_id: spanId,
        caller,
    }));
}
/**
 * Logger
 * @example
 * ```ts
 * logger.info({
 *    context: 'http',
 *    message: 'REQUEST ERROR',
 *    meta: {
 *      query: ctx.request.query,
 *      body: ctx.request.body,
 *      params: ctx.params,
 *    },
 *    exception: {
 *      message,
 *      stack: error.stack,
 *    },
 *    http_status: status,
 * });
 * ```
 */
class Logger {
    static _env = process.env.ENV;
    static _writer = this._env === 'development' ? stringWriter : jsonWriter;
    static log(args) {
        this._log(args);
    }
    static debug(args) {
        this._log({ ...args, level: LEVEL.DEBUG });
    }
    static info(args) {
        this._log({ ...args, level: LEVEL.INFO });
    }
    static warning(args) {
        this._log({ ...args, level: LEVEL.WARNING });
    }
    static error(args) {
        this._log({ ...args, level: LEVEL.ERROR });
    }
    static setEnv(env) {
        this._env = env;
    }
    static _log(args) {
        this._writer(this._buildArgs(args));
    }
    static _buildArgs(args) {
        const traceArgs = this._buildTraceArgs();
        return {
            context: 'APP',
            level: LEVEL.INFO,
            ...traceArgs,
            ...args,
        };
    }
    static _buildTraceArgs() {
        const currentSpan = trace.getActiveSpan();
        const spanContext = currentSpan?.spanContext();
        if (spanContext) {
            return {
                trace_id: spanContext.traceId,
                span_id: spanContext.spanId,
            };
        }
    }
}
export { LEVEL, Logger as logger };
/** @deprecated Use named export */
export default Logger;
